import firebase from 'firebase';
import axios from 'axios';

export const sampleAction = ()=> {
    return (dispatch)=> {
        dispatch({
            type: 'SAMPLE_ACTION'
        });


    }
}

export const getUserLocation = ()=> {
    return (dispatch)=> {
        
        
        navigator.geolocation.getCurrentPosition(
            (position)=>{
                dispatch({
                    type: 'UPDATE_USER_LOCATION',
                    payload : {lat : position.coords.latitude, lng : position.coords.longitude}
                });
        
            },
            ()=>{
                console.log('user declined to share location - use default');
                dispatch({
                    type: 'UPDATE_USER_LOCATION',
                    payload :{ lat: 51.491758, lng: 0.1596895000000131 }
                });
            }
        );



    }
}


export const updateUserLocation = (location)=> {
    return (dispatch)=> {
        dispatch({
            type: 'UPDATE_USER_LOCATION',
            payload : location
        });


    }
}


export const loadFirebase = ()=> {





    return (dispatch)=> {

        dispatch({type: 'FIREBASE_INITIALISING'})

        const initFirebase = (config)=>{


            if (!firebase.apps.length) {
                firebase.initializeApp(config);
                firebase.firestore().settings({ timestampsInSnapshots: true});
            }



            firebase.database().ref('.info/connected').on('value', (snap)=> {
                console.log('connected', snap.val());
                dispatch({type: 'FIREBASE_CONNECTED', payload: snap.val()})
            })

            firebase.auth().onAuthStateChanged((user)=> {
                if (user) {
                    firebase.database().ref('permissions/' + user.uid).on('value', (snap)=> {
                        if (snap.val()) {
                            dispatch({type: 'USER_PERMISSIONS_UPDATE', payload: snap.val()})
                        }
                        dispatch({type: 'USER_PERMISSIONS_LOADED'})

                    })
                }
                dispatch({type: 'FIREBASE_AUTHSTATE_CHANGE', payload: user})
            })

            firebase.firestore().enablePersistence()
                .then(
                    ()=>{
                        dispatch({type: 'FIRESTORE_PERSITANCE_ENABLED', payload: true})
                    },
                    (err)=>{
                        dispatch({type: 'FIRESTORE_PERSITANCE_ENABLED', payload: err})
                    }
                )
        }


        axios.get('/__/firebase/init.json')
            .then(
                (resp)=> {
                    if(resp.data.databaseURL){
                        //it's a valid firebase object
                        initFirebase(resp.data);
                    } else {
                        initFirebase({
                            apiKey: "AIzaSyBVFAJJM-VC-mzou7pvcjvcbOAxNBdlUHo",
                            authDomain: "givr-dev.firebaseapp.com",
                            databaseURL: "https://givr-dev.firebaseio.com",
                            projectId: "givr-dev",
                            storageBucket: "",
                            messagingSenderId: "146949878998"
                        });
                        console.log('response invalid');
                    }
                }
            )
            .catch((e)=> {
                //default for local testing
                initFirebase({
                    apiKey: "AIzaSyBVFAJJM-VC-mzou7pvcjvcbOAxNBdlUHo",
                    authDomain: "givr-dev.firebaseapp.com",
                    databaseURL: "https://givr-dev.firebaseio.com",
                    projectId: "givr-dev",
                    storageBucket: "",
                    messagingSenderId: "146949878998"
                });

            })

        //load auth from /__/firebase/init.json - JSON representation of the configuration
        //https://firebase.googleblog.com/2017/04/easier-configuration-for-firebase-on-web.html
        //Maybe load it and if it fails (which it will locally, fallback to the default test one).



    }
}






// WEBPACK FOOTER //
// ./src/actions/appActions.js